import React from 'react';
import multiTenantTabs from './multi-tenant-tables/index';
import PropertyInformation from './tabs-components/PropertyInformation';
import CurrentRR from './tabs-components/CurrentRR';
import CurrentReimbursement from './tabs-components/CurrentReimbursement';
import Pricing from './tabs-components/Pricing';
import Expenses from './tabs-components/Expenses';
import Marketing from './tabs-components/Marketing';
import {buildGeneralInformationRow} from './multi-tenant-tables/current-rr-tab/general-information';
import {buildDetailedInformationRow} from './multi-tenant-tables/current-rr-tab/detailed-information';
import {buildDetailedInformationRowReimbursement} from './multi-tenant-tables/current-reimbursement-tab/detailed-information';
import {buildRentRollRow} from './multi-tenant-tables/marketing-tab/rent-roll';
import {buildReimbursementsRow} from "./multi-tenant-tables/marketing-tab/reimbursements";
import {buildReimbursementTypes, buildReimbursableOpEx} from './multi-tenant-tables/current-reimbursement-tab/annex';
import request from "arcdynamic-request";
import unitedStates from 'united-states';
import {
    dateProps,
    numberProps,
    stringProps,
    checkboxProps,
    tenantFields,
    tenantTypeFields,
    defaultValues,
    pricingChanges
} from './mt-fields-to-save';
import BaseTabComponent from "./tabs-components/BaseTabComponent";
import {stringISOtoUS, stringUStoISO} from '../../date-converter';
import PrintMultiTenant from "../PrintMultiTenant";
import {addCommasToNumber, findTenantRow} from "../../utils";
import {mergePropertySingletonRows} from '../../utils/mergePropertySingletonRows';
import {UNDERWRITING_MULTI_TENANT, UNDERWRITING_PARCELS, UNDERWRITING_EXPENSES_CAMS, UNDERWRITING_TENANT_TYPES, UNDERWRITING_TENANTS, TENANTS, PROPOSAL, PRICING_ANALYSIS} from '../../consts/tables';
import {UNDERWRITING_TENANT_LIST} from '../../consts/queries';
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import filter from "../../filter";
import {defaultReimbursementTypesNo, taxAssessmentsNo, reimbursementTypesNo, camDefaultRowNo, computeReimbTypes} from "./utils";
import {buildSummedRentRoll} from "./multi-tenant-tables/marketing-tab/sumed-rent-roll";
import {buildSummedReimbursements} from "./multi-tenant-tables/marketing-tab/sumed-reimbursements";
import { getData, manageData } from '../../requests/CRUD';
import PopupDialog from '../PopupDialog';
import { getCurrentAccess } from '../../access';
import { editsEverySummitRecord } from '../../access-levels';
import {
    indexTenantTypesByReimbIndex,
    resolveTenantTypeRow,
    buildTenantTypeSaveRow,
} from './reimbTypesPersistence';

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');
const find = require('lodash.find');

function preProcess(items){
    const ITEMS = JSON.parse(items)
    return ITEMS.map((val)=>val.link)
}
const defualtStaticImages = [
    '5e0c4d6dce9179486afe80a6477eff1dc58162e4b98f229a6803f502ffa805f1e81aed03eed324daeaaf10e93a7465738358eb56a56445fe4d536345f9a7d7f1_Multi_Tenant_image_2.jpg',
    'd58b316b34600cd5b8e9e87d9dbd163fa1b5076618560fade22ac6894d20b7bfd8721e0476f67f93587f18dc89b275ea5f51a1548d971b272d08a579121ea822_Multi_Tenant_image_3.jpg',
    '049d13b291386df926097985dc53dc023dd70de7260c6e9ddd467ef42621a2db782344522adfb273463c71ec10413475f386a9af78b72f3f42db171d5ad92e3f_Multi_Tenant_image_4.jpg',
    '70f7dac2885221da236fffd73dd1c93c05270e056443f2f1525f8ccb021ff317ca7495c7945aa0e5358c904f1199ee3e73a8acf3b83121c288d59f3845c6a75d_Multi_Tenant_image_5.jpg',
    'ddc9908769f6caa303d66bb823f677bd534811083a03098c3ca995e2ec1892905ff9102976592deb8b0caa87bc53410a9f019f856bca78c72dacba235a718e9f_Multi_Tenant_image_6.jpg',
    'f49b363cdde33c4d97e2d0b6b6b496445113d42f4986c7ac08f79af7c54939f90e4fe65091209b30be80b27867e5fb38ff616ff26ebdd8e740d99a3756bf048d_Multi_Tenant_image_7.jpg',
    '85126a8b64d985427432ff35d2ae06944b148531688f2cdd78c4a8e5868d96bc9d2dd009209dff20508bcc979c1d5c46c21b133b0dfd6cdae63534163e3f58a7_Multi_Tenant_image_8.jpg',
    '51c4e133099e07ad2b3a8403232800f37b6e34c5def27d68b2d52636491e723e2a82867987933f3b180bc81f69e5f4a8d6a1456f6cf91d4eb2299b44f419017b_Multi_Tenant_image_9.jpg',
]
export default class UnderwritingMultiTenant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                tabs: multiTenantTabs,
            },
            original: {
                tabs: multiTenantTabs,
            },
            selectedTab: 'marketing-tab',
            newData: null,
            parcelsData: null,
            camData: null,
            tenantsData: null,
            tenantTypeData: null,
            underwritingId: null,
            sqFtUpdated: false,
            camPSFSumUpdated: false,
            mgmtUpdated: false,
            insuranceUpdated: false,
            taxesUpdated: false,
            dataLoaded: false,
            isProformaVisible: false,
            isProformaVisiblePricing: false,
            isAdditionalPriceVisible: false,
            isMarketingAdditionalPriceVisible: false,
            displayPopupSubmit: false,
            sortState: 'default',
            movedRows: false,
            reimbTypesManuallyModified: false,
            originalReimbTypesManuallyModified: false,
            staticImages:[],
            staticImagesLoaded: false,
            staticImagesLoading: true,
            isBusy: false,
            isDialogueOpen: false,
            dialogTitle:'',
            isCaliforniaProposal: false
        };
        this.getUnderwritingData = this.getUnderwritingData.bind(this);
        this.tabValueChange = this.tabValueChange.bind(this);
        this.tabValuesChange = this.tabValuesChange.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRowCurrentRR = this.deleteRowCurrentRR.bind(this);
        this.deleteRowCAM = this.deleteRowCAM.bind(this);
        this.moveRow = this.moveRow.bind(this);
        this.moveCorrespondingRows = this.moveCorrespondingRows.bind(this);
        this.reassignTenantRowIds = this.reassignTenantRowIds.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.findTenant = this.findTenant.bind(this);
        this.saveTenant = this.saveTenant.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleExpandShow = this.handleExpandShow.bind(this);
        this.togglePopupMessage = this.togglePopupMessage.bind(this);
        this.setState = this.setState.bind(this);
        this.sortTenants = this.sortTenants.bind(this);
        this.getStaticImages = this.getStaticImages.bind(this);
        this.getProductType = this.getProductType.bind(this);
        this.handleCaliforniaToggle = this.handleCaliforniaToggle.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.beforeSubmit = this.beforeSubmit.bind(this);
    }

    async componentDidMount() {
        this.injectPrintPageSize();
        try {
            await this.getUnderwritingData();
            // Computing heavily-used values at the start of the render.
            const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
            const state = UnderwritingMultiTenant.setDefaultValues(this.state.data, precomputedValues);
            this.setState(state, () => {
                this.getStaticImages(this.getProductType());
            });
        } catch (e) {
            console.error('UnderwritingMultiTenant mount error:', e);
            this.setState({ staticImagesLoading: false });
        }
    }

    componentWillUnmount() {
        this.removePrintPageSize();
    }

    injectPrintPageSize() {
        if (typeof document === 'undefined' || this._printPageStyles) return;
        // Landscape on a REAL paper size (letter) so the layout maps 1:1 onto the
        // sheet with no driver scale-to-fit. Each proposal sheet is a fixed
        // 1056x810px design (letter landscape at 96dpi), scaled to fit whatever
        // printable area the print dialog produces: in print media 100vw/100vh equal
        // the page area (paper minus the dialog's margins), so
        // zoom: min(100vw/width, 100vh/height) fills the width edge-to-edge at
        // Margins: None and shrinks just enough at Minimum/Default — each section
        // always lands whole on its own page at 100% scale, on Letter or A4.
        // Denominators carry ~0.4% slack (1060/813 vs 1056/810) so rounding can
        // never spill a 1px sliver onto an extra page. The static zoom before it is
        // the fallback for engines without calc() length division (pre-2024).
        //
        // `zoom` (not transform) because Chromium paginates on zoomed layout. The
        // root width is pinned in PX, not %: Blink zooms px lengths but resolves %
        // widths against the parent unshrunk, so a %-width root would keep sheets
        // full-width while their px heights shrink — distorting the aspect and
        // letterboxing every object-fit image. A px base scales uniformly; auto
        // margins center the scaled sheets on the page.
        const css = '@media print {'
            + ' @page { size: letter landscape !important; margin: 0 !important; }'
            + ' .SingleTenant, .PrintMultiTenant {'
            + ' zoom: 0.93;'
            + ' zoom: min(calc(100vw / 1060px), calc(100vh / 813px));'
            + ' width: 1056px !important; max-width: none !important;'
            + ' margin-left: auto !important; margin-right: auto !important;'
            + ' } }';
        const first = document.createElement('style');
        first.setAttribute('data-proposal-page-size', 'first');
        first.innerHTML = css;
        const last = document.createElement('style');
        last.setAttribute('data-proposal-page-size', 'last');
        last.innerHTML = css;
        document.head.insertBefore(first, document.head.firstChild);
        document.head.appendChild(last);
        this._printPageStyles = [first, last];
    }

    removePrintPageSize() {
        (this._printPageStyles || []).forEach((s) => s.parentNode && s.parentNode.removeChild(s));
        this._printPageStyles = null;
    }

    getProductType() {
        const category = this.props.data.CATEGORY;
        if (category === 'apartments') return 'apartments';

        const isVacant = (this.props.data.MULTI_TENANT_SUBCATEGORY && this.props.data.MULTI_TENANT_SUBCATEGORY.toLowerCase().includes('vacant'))
            || (this.props.data.LEASE_TYPE && this.props.data.LEASE_TYPE.toLowerCase().includes('vacant'));

        // California toggle only applies to retail properties and overrides the vacant suffix
        // because no `retail-MT-CA-vacant` product type exists.
        if (category === 'retail' && this.state.isCaliforniaProposal) {
            return 'retail-MT-CA';
        }

        // Proforma pricing uses a separate set of default pages uploaded under the
        // "RETAIL - MT PROFORMA" tab in the Proposals UI.
        if (category === 'retail' && this.isProformaPricing()) {
            return 'retail-MT-proforma';
        }

        let type = category + '-MT';
        if (isVacant) type = type + '-vacant';
        return type;
    }

    isProformaPricing() {
        try {
            return !!this.state.data.tabs['pricing-tab'].tables['pricing-analysis']
                .rows['proforma-checkbox'].valueCells[1].value;
        } catch (e) {
            return false;
        }
    }

    handleCaliforniaToggle() {
        this.setState(
            (prev) => ({ isCaliforniaProposal: !prev.isCaliforniaProposal }),
            () => { this.getStaticImages(this.getProductType()); }
        );
    }

    static findCamRowNO(rows) {
        let lastCamRowIndex = -1, camNo = 0;
        rows.map((row, index) => {
            if (/(cam-[0-9])/g.test(row[0])) {
                lastCamRowIndex = index;
                camNo++;
            }
        });
        return {lastCamRowIndex, camNo};
    }

    setForceStatic(newData, prop) {
        if (prop.hasOwnProperty('valueCellIndex')) {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].forceStatic = !prop.hasOwnProperty('forceStatic');
        } else {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        }
    }

    setFieldsDisabled(data) {
        const newData = cloneDeep(data);

        stringProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        dateProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        numberProps.map(prop => {
            this.setForceStatic(newData, prop);
        });

        for (let index = 0; index < taxAssessmentsNo; index++) {
            newData.tabs['property-information-tab'].tables['parcel'].rows[`tax-assessment-${index+1}`].valueCells.map(cell => {
                cell.forceStatic = true;
            });
        }

        const camRows = newData.tabs['expenses-tab'].tables['expenses'].rows;
        const cams = Object.entries(camRows);
        let {camNo} = UnderwritingMultiTenant.findCamRowNO(cams);
        for (let index = 0; index < camNo; index++) {
            camRows[`cam-${index+1}`].valueCells.map(cell => {
                if (cell.editable) {
                    cell.forceStatic = true;
                }
            });
        }

        const tenantNo = Object.keys(newData.tabs['current-rr-tab'].tables['general-information'].rows).length;
        tenantFields.map(prop => {
            for (let index = 0; index < tenantNo; index++) {
                newData.tabs[prop.tab].tables[prop.table].rows[index].valueCells[prop.valueCellIndex].forceStatic = true;
            }
        });

        const reimbursementTypes = newData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        for (let index = 0; index < reimbursementTypesNo; index++) {
            const row = reimbursementTypes[index];
            row.valueCells.map((cell, index) => {
                if (![0, 8, 10].includes(index)) {
                    cell.forceStatic = true;
                }
            });
        }

        return newData;
    }

    async getUnderwritingData(isSaved) {
        let data = cloneDeep(this.state.data);
        const propsData = this.props.data;
        let snapshotTenantsData = null;
        let tenantsData = null;

        // Set the dropdown values
        data.tabs['property-information-tab'].tables['general-information'].rows['state'].dropdownValues = unitedStates;

        if (!this.props.data.ARCIMEDES_ROW_ID) {
            await this.initTenants(data, [{}], false);
            return;
        }

        let res;
        if (this.props.historySnapshot && this.props.historySnapshot.multiTenant) {
            const snapshot = this.props.historySnapshot.multiTenant;
            tenantsData = Array.isArray(snapshot.tenants) ? snapshot.tenants : [];
            snapshotTenantsData = tenantsData;

            let foundTenants = [{}];
            let isProformaPricingView = false;
            if (tenantsData.length) {
                foundTenants = [];
                isProformaPricingView = tenantsData[0].PROFORMA_CHECKBOX === null ? '' : !!parseInt(tenantsData[0].PROFORMA_CHECKBOX);

                tenantsData.forEach((row, index) => {
                    if (!foundTenants[index]) foundTenants[index] = {};
                    tenantFields.forEach((prop) => {
                        switch (prop.type) {
                            case 'string':
                                foundTenants[index][prop.key] = row[prop.key] || '';
                                break;
                            case 'number': {
                                let value;
                                if (prop.withReplace && prop.withToFixed) {
                                    value = row[prop.key] ? parseFloat(row[prop.key].replace(/,/g, '')).toFixed(2) : '';
                                } else if (prop.withToFixed) {
                                    value = row[prop.key] ? parseFloat(row[prop.key]).toFixed(2) : '';
                                } else if (prop.withReplace) {
                                    value = row[prop.key]
                                        ? parseFloat((typeof row[prop.key] === 'string' ? row[prop.key] : String(row[prop.key])).replace(/,/g, ''))
                                        : '';
                                } else {
                                    value = parseFloat(row[prop.key]) || '';
                                }
                                foundTenants[index][prop.key] = value;
                                break;
                            }
                            case 'date':
                                foundTenants[index][prop.key] = row[prop.key] ? stringISOtoUS(row[prop.key]) : '';
                                break;
                        }
                    });
                });
            }

            this.setState({ tenantsData });
            await this.initTenants(data, foundTenants, isProformaPricingView);
            res = [
                { success: true, data: [snapshot.underwriting || {}] },
                { success: true, data: Array.isArray(snapshot.parcels) ? snapshot.parcels : [] },
                { success: true, data: Array.isArray(snapshot.cams) ? snapshot.cams : [] },
                { success: true, data: Array.isArray(snapshot.tenantTypes) ? snapshot.tenantTypes : [] },
            ];
        } else {
            const refreshedTenantsData = await this.getTenants(data, undefined, undefined, undefined, false);
            if (refreshedTenantsData) {
                tenantsData = refreshedTenantsData;
            }
            let id = this.props.data.ARCIMEDES_ROW_ID;
            if (id && typeof (id) !== 'string') {
                id = this.props.data.ARCIMEDES_ROW_ID.toString();
            }
            res = await Promise.all([
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.getData',
                    params: ['code', UNDERWRITING_MULTI_TENANT, {
                        filter: [{
                            'text': id,
                            'code': 'PROPERTY_ID',
                            'type': 'exact',
                        }],
                    }],
                }),
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.getData',
                    params: ['code', UNDERWRITING_PARCELS, {
                        filter: [{
                            'text': id,
                            'code': 'PROPERTY_ID',
                            'type': 'exact',
                        }],
                        order: [{
                            code: 'PARCEL',
                            type: 'asc',
                        }]
                    }],
                }),
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.getData',
                    params: ['code', UNDERWRITING_EXPENSES_CAMS, {
                        filter: [{
                            'text': id,
                            'code': 'PROPERTY_ID',
                            'type': 'exact',
                        }, {
                            'text': '',
                            'code': 'DELETED',
                            'type': 'null',
                        }],
                        filterType: 'and',
                        order: [{
                            code: 'CAM_INDEX',
                            type: 'asc',
                        }]
                    }],
                }),
                getData({
                    tableCode: UNDERWRITING_TENANT_TYPES,
                    options: {
                        filter: [{
                            'text': id,
                            'code': 'PROPERTY_ID',
                            'type': 'exact',
                        }],
                        order: [{
                            code: 'REIMB_TYPES_INDEX',
                            type: 'asc',
                        }]
                    }
                })
            ]);
        }
        if (res) {
            const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
            const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'];
            const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'];
            const tenantOpEx = data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'];
            const tenantOpExProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursable-op-ex'];
        let parcelsData = null;
        let camData = null;
        let tenantTypeData = null;
        let reimbTypesManuallyModified = false;

            // Manage data from PROPERTIES table
            stringProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] || '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] || '';
                    }
                }
            });

            dateProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    }
                }
            });

            numberProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    let value;
                    if (prop.withReplace && prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')).toFixed(2) : '';
                    } else if (prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key]).toFixed(2) : '';
                    } else if (prop.withReplace) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    } else {
                        value = parseFloat(propsData[prop.key]) || '';
                    }
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = value;
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = value;
                    }
                }
            });

            // Manage data from UNDERWRITING_TENANT_TYPES table
            if (res[3] && res[3].success && Array.isArray(res[3].data)) {
                tenantTypeData = res[3].data.length > 0 ? cloneDeep(res[3].data) : Array(defaultReimbursementTypesNo).fill({});
                const tenantTypesByIndex = indexTenantTypesByReimbIndex(tenantTypeData);

                tenantOpEx.rows = buildReimbursableOpEx('current-reimbursement-tab');
                tenantOpExProForma.rows = buildReimbursableOpEx('proforma-reimbursement-tab');

                tenantTypes.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = resolveTenantTypeRow(tenantTypesByIndex, index, tenantTypeData);
                    return buildReimbursementTypes(typesDataRow, index, 'current-reimbursement-tab');
                }));
                tenantTypesProForma.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = resolveTenantTypeRow(tenantTypesByIndex, index, tenantTypeData);
                    return buildReimbursementTypes(typesDataRow, index, 'proforma-reimbursement-tab');
                }));
            }

            // Manage data from UNDERWRITING_EXPENSES_CAMS table
            if (res[2] && res[2].success && Array.isArray(res[2].data)) {
                camData = cloneDeep(res[2].data);
                const rows = Object.entries(data.tabs['expenses-tab'].tables['expenses'].rows);
                let {camNo} = UnderwritingMultiTenant.findCamRowNO(rows);

                camData.map(row => {
                    if (camData.length > camNo) {
                        const dataWithRows = this.addRow(['expenses-tab', 'current-reimbursement-tab'], [['expenses'], ['reimbursable-op-ex']], 'cam-1', true, true, data);
                        data.tabs['expenses-tab'].tables['expenses'].rows = dataWithRows.tabs['expenses-tab'].tables['expenses'].rows;
                        data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows = dataWithRows.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows;
                        camNo = camNo + camDefaultRowNo;
                    }
                    if(data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`]){
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[0].value = row.CAM_NAME || '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[2].value = row.CAM_VALUE ? parseFloat(row.CAM_VALUE).toFixed(2) : '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[5].value = row.PROFORMA_CAM_VALUE ? parseFloat(row.PROFORMA_CAM_VALUE).toFixed(2) : '';
                        data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[7].value = row.ARCIMEDES_ROW_ID;
                    }
                });
            }

            // Manage data from UNDERWRITING_MULTI_TENANT table
            if (res[0] && res[0].success && Array.isArray(res[0].data)) {
                const result = mergePropertySingletonRows(res[0].data);

                stringProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] || '';
                        }
                    }
                });

                dateProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        const loaded = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            const cell = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex];
                            cell.value = loaded || cell.value || '';
                        } else {
                            const row = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey];
                            row.value = loaded || row.value || '';
                        }
                    }
                });

                numberProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            if (prop.withReplace && prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key].replace(/,/g, '')).toFixed(2) : '';
                                return;
                            }
                            if (prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key]).toFixed(2) : '';
                                return;
                            }
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = parseFloat(result[prop.key]) || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = parseFloat(result[prop.key]) || '';
                        }
                    }
                });

                checkboxProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex'))
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] === null ? '' : !!parseInt(result[prop.key]);
                        else
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] === null ? '' : !!parseInt(result[prop.key]);
                    }
                });

                const isProformaPricing = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;
                const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
                // Use freshly loaded tenantsData — stale this.state.tenantsData can rebuild
                // marketing rent-roll with fewer rows than current-rr general-information,
                // which crashes PrintMultiTenant getRentRoll after save.
                data.tabs = UnderwritingMultiTenant.changePricingView(
                    data.tabs,
                    isProformaPricing,
                    isAssumableLoan,
                    snapshotTenantsData || tenantsData || this.state.tenantsData
                );

                reimbTypesManuallyModified = !!result.REIMB_TYPES_MANUALLY_MODIFIED;
            }

            // Manage data from UNDERWRITING_PARCELS table
            if (res[1] && res[1].success && Array.isArray(res[1].data)) {
                parcelsData = cloneDeep(res[1].data);

                parcelsData.map((row, index) => {
                    parcels[`tax-assessment-${index + 1}`].valueCells[0].value = row.PARCEL || '';
                    parcels[`tax-assessment-${index + 1}`].valueCells[1].value = parseFloat(row.ASSESSED_VALUE) || '';
                    parcels[`tax-assessment-${index + 1}`].valueCells[2].value = parseFloat(row.TAX_LIABILITY) || '';
                });
            }

            this.setState({
                data,
                original: cloneDeep(data),
                parcelsData,
                camData,
                tenantTypeData,
                tenantsData: tenantsData || this.state.tenantsData,
                underwritingId: res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length
                    ? mergePropertySingletonRows(res[0].data).ARCIMEDES_ROW_ID
                    : null,
                reimbTypesManuallyModified,
                originalReimbTypesManuallyModified: reimbTypesManuallyModified,
                sqFtUpdated: false,
                camPSFSumUpdated: false,
                mgmtUpdated: false,
                insuranceUpdated: false,
                taxesUpdated: false,
                isBusy: false
            }, () => {
                if (isSaved) this.props.parentSetData({success: 'Saved'});
            });
        }
    }

    async getTenants(data, key, sort, sortState, commitState = true) {
        const query = {
            PROPERTY_ID: this.props.data.ARCIMEDES_ROW_ID,
        };
        if (key && sort) query.order = `${key}.${sort}`;
        else query.order = 'TENANT_ROW_ID.asc';
        const options = filter(query, 'underwritingMT');
        const res = await executeBackendQuery({queryName: UNDERWRITING_TENANT_LIST, options});

        let foundTenants = [{}];
        let isProformaPricingView = false;
        let tenantsData = null;
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            tenantsData = [...res.data].sort((a, b) => {
                const rowDiff = parseInt(a.TENANT_ROW_ID != null ? a.TENANT_ROW_ID : 0, 10) - parseInt(b.TENANT_ROW_ID != null ? b.TENANT_ROW_ID : 0, 10);
                if (rowDiff !== 0) {
                    return rowDiff;
                }
                return Number(a.ARCIMEDES_ROW_ID) - Number(b.ARCIMEDES_ROW_ID);
            });
            isProformaPricingView = tenantsData[0].PROFORMA_CHECKBOX === null ? '' : !!parseInt(tenantsData[0].PROFORMA_CHECKBOX);

            tenantsData.forEach((row, index) => {
                tenantFields.map(prop => {
                    if (!foundTenants[index]) {
                        foundTenants[index] = {};
                    }
                    switch (prop.type) {
                        case 'string': {
                            if (prop.key === 'TENANT_ROW_ID' || prop.key === 'ARCIMEDES_ROW_ID') {
                                foundTenants[index][prop.key] = row[prop.key] != null && row[prop.key] !== ''
                                    ? String(row[prop.key])
                                    : '';
                            } else {
                                foundTenants[index][prop.key] = row[prop.key] || '';
                            }
                            break;
                        }
                        case 'number': {
                            let value;
                            if (prop.withReplace && prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key].replace(/,/g, '')).toFixed(2) : '';
                            } else if (prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key]).toFixed(2) : '';
                            } else if (prop.withReplace) {
                                value = row[prop.key]
                                ? parseFloat(
                                    (typeof row[prop.key] === 'string' 
                                        ? row[prop.key] 
                                        : String(row[prop.key])
                                    ).replace(/,/g, '')
                                    )
                                : '';
                            } else {
                                value = parseFloat(row[prop.key]) || '';
                            }

                            foundTenants[index][prop.key] = value;
                            break;
                        }
                        case 'date': {
                            foundTenants[index][prop.key] = row[prop.key] ? stringISOtoUS(row[prop.key]) : '';
                            break;
                        }
                    }
                });
                foundTenants[index].TENANT_ROW_ID = String(index);
            });

            const state = {
                tenantsData: tenantsData,
            };
            if (sortState) state.sortState = sortState;

            if (commitState) {
                this.setState(state);
            }
        }
        if(sortState === "desc"){
            foundTenants.sort((a, b) => {
                return b.RR_SUITE_CODE.localeCompare(a.RR_SUITE_CODE, undefined, { numeric: true });
            });
        }else if(sortState === "asc"){
            foundTenants.sort((a, b) => {
                return a.RR_SUITE_CODE.localeCompare(b.RR_SUITE_CODE, undefined, { numeric: true });                
            });
        }  
        
        await this.initTenants(data, foundTenants, isProformaPricingView, commitState);
        return tenantsData;
    }

    initTenants(data, tenants, isProformaPricingView, commitState = true) {
        const generalInformation = data.tabs['current-rr-tab'].tables['general-information'];
        const detailedInformation = data.tabs['current-rr-tab'].tables['detailed-information'];
        const generalInformationProForma = data.tabs['proforma-rr-tab'].tables['general-information'];
        const detailedInformationProForma = data.tabs['proforma-rr-tab'].tables['detailed-information'];
        const proformaReimbursementDetailedInformation = data.tabs['proforma-reimbursement-tab'].tables['detailed-information'];
        const currentReimbursementDetailedInformation = data.tabs['current-reimbursement-tab'].tables['detailed-information'];
        const marketingRentRoll = data.tabs['marketing-tab'].tables['rent-roll'];
        const marketingReimbursements = data.tabs['marketing-tab'].tables['reimbursements'];
        const marketingSummedRentRoll = data.tabs['marketing-tab'].tables['sumed-rent-roll'];
        const marketingSummedReimbursements = data.tabs['marketing-tab'].tables['sumed-reimbursements'];

        generalInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'current-rr-tab');
        }));
        detailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'current-rr-tab');
        }));
        generalInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'proforma-rr-tab');
        }));
        detailedInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'proforma-rr-tab');
        }));
        proformaReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'proforma-reimbursement-tab');
        }));
        currentReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'current-reimbursement-tab');
        }));
        marketingRentRoll.rows = Object.assign({}, tenants.map(() => {
            return buildRentRollRow(isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab', isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
        }));
        marketingReimbursements.rows = Object.assign({}, tenants.map(() => {
            return buildReimbursementsRow(isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab');
        }));
        marketingSummedRentRoll.rows = buildSummedRentRoll(isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab');
        marketingSummedReimbursements.rows = buildSummedReimbursements(isProformaPricingView ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab', isProformaPricingView ? 'proforma-rr-tab' : 'current-rr-tab');

        if (commitState) {
            this.setState({
                data: data,
                original: cloneDeep(data)
            });
        }
    }

    static setDefaultValue(tabs, field, rowIdentifier, precomputedValues) {
        const defaultValue = field.getDefaultValue({index: rowIdentifier, tabs, precomputedValues}) || '';
        const row = tabs[field.tab].tables[field.table].rows[rowIdentifier];
        if (field.hasOwnProperty('valueCellIndex')
            && (row &&
                row.valueCells &&
                field &&
                Number.isInteger(field.valueCellIndex) &&
                field.valueCellIndex >= 0 &&
                field.valueCellIndex < row.valueCells.length &&
                row.valueCells[field.valueCellIndex].type === 'boolean' &&
                // Only fill defaults when unset — never overwrite an explicit false (unchecked).
                (row.valueCells[field.valueCellIndex].value === ''
                    || row.valueCells[field.valueCellIndex].value === null
                    || row.valueCells[field.valueCellIndex].value === undefined)
                || row &&
                row.valueCells &&
                Array.isArray(row.valueCells) &&
                Number.isInteger(field.valueCellIndex) &&
                field.valueCellIndex >= 0 &&
                field.valueCellIndex < row.valueCells.length &&
                row.valueCells[field.valueCellIndex].type !== 'boolean' &&
                !row.valueCells[field.valueCellIndex].value
                && row.valueCells[field.valueCellIndex].value !== 0))
            row.valueCells[field.valueCellIndex].value = defaultValue;
        if (row && !row.value)
            row.value = defaultValue;
        return tabs;
    }

    static setDefaultValues(resultData, precomputedValues) {
        let data = cloneDeep(resultData);

        defaultValues.map(field => {
            if (field.hasOwnProperty('tableKey'))
                data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, field.tableKey, precomputedValues);
            else {
                if (field.tab === 'proforma-rr-tab') {
                    const tenantRowsNo = Object.keys(data.tabs[field.tab].tables['detailed-information'].rows).length;
                    for (let index = 0; index < tenantRowsNo; index++) {
                        data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
                if (['current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(field.tab)) {
                    for (let index = 0; index < defaultReimbursementTypesNo; index++) {
                        data.tabs = UnderwritingMultiTenant.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
            }
        });

        return {
            data: data,
            dataLoaded: true,
        };
    }

    static changePricingView(tabs, isProformaPricing, isAssumableLoan, tenants) {
        pricingChanges.map(prop => {        
            if (prop.hasOwnProperty('valueCellIndex'))
                tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex][prop.property] = prop.getValue(isProformaPricing, isAssumableLoan);
            else
                tabs[prop.tab].tables[prop.table].rows[prop.tableKey][prop.property] = prop.getValue(isProformaPricing, isAssumableLoan);
        });
        // Marketing print rows must stay keyed 1:1 with the general-information table
        // it is paired with, so never exceed either rent-roll's row count
        // (avoids getRentRoll crashes after save/reload).
        const currentRowCount = Object.keys(tabs['current-rr-tab'].tables['general-information'].rows || {}).length;
        const proformaTable = tabs['proforma-rr-tab'] && tabs['proforma-rr-tab'].tables['general-information'];
        const proformaRowCount = Object.keys((proformaTable && proformaTable.rows) || {}).length;
        const generalRowCount = proformaRowCount ? Math.min(currentRowCount, proformaRowCount) : currentRowCount;
        const marketingRowCount = generalRowCount || (tenants && tenants.length) || 0;
        if (marketingRowCount > 0) {
            const marketingRows = Array.from({length: marketingRowCount}, () => (
                buildRentRollRow(isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab', isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab')
            ));
            const reimbursementRows = Array.from({length: marketingRowCount}, () => (
                buildReimbursementsRow(isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab')
            ));
            tabs['marketing-tab'].tables['rent-roll'].rows = Object.assign({}, marketingRows);
            tabs['marketing-tab'].tables['reimbursements'].rows = Object.assign({}, reimbursementRows);
        }
        tabs['marketing-tab'].tables['sumed-rent-roll'].rows = buildSummedRentRoll(isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab');
        tabs['marketing-tab'].tables['sumed-reimbursements'].rows = buildSummedReimbursements(isProformaPricing ? 'proforma-reimbursement-tab' : 'current-reimbursement-tab', isProformaPricing ? 'proforma-rr-tab' : 'current-rr-tab');
        return tabs;
    }

    togglePopupMessage() {
        this.setState({displayPopupSubmit: !this.state.displayPopupSubmit})
    }

    changeTab(tabKey) {
        const state = cloneDeep(this.state);
        state.selectedTab = tabKey;
        this.setState(state);
    }

    tabValueChange({tab, table, row, value, columnIndex, reimbTypesManuallyModified, assumableLoanPricingViewChange}) {
        const data = cloneDeep(this.state.data);
        if (columnIndex === undefined || columnIndex === null) {
            data.tabs[tab].tables[table].rows[row].value = value;
        } else {
            data.tabs[tab].tables[table].rows[row].valueCells[columnIndex].value = value;
            if (columnIndex === 2 && row === "additional-price") {
                data.tabs[tab].tables[table].rows[row].valueCells[6].value = value;
            }
        }

        const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
        const isProformaPricing = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['proforma-checkbox'].valueCells[1].value;
        if(assumableLoanPricingViewChange){
            data.tabs = UnderwritingMultiTenant.changePricingView(data.tabs, isProformaPricing, isAssumableLoan, this.state.tenantsData);
        }
        const state = {
            data,
        };
        if (reimbTypesManuallyModified)
            state.reimbTypesManuallyModified = reimbTypesManuallyModified;
        this.setState(state);
    }

    tabValuesChange({tabs, tables, rowIds, values, columnIds, sqFtChanged = null, camChanged = null, mgmtChanged = null, insuranceChanged = null, taxesChanged = null, reimbTypesManuallyModified, proformaPricingViewChange, isProformaPricing}) {
        const data = cloneDeep(this.state.data);
        tabs.forEach((tab, index) => {
            const table = tables[index];
            const rowIndex = rowIds[index];
            const columnIndex = columnIds[index];
            const value = values[index];
            if (columnIndex === undefined || columnIndex === null) {
                data.tabs[tab].tables[table].rows[rowIndex].value = value;
            } else {
                data.tabs[tab].tables[table].rows[rowIndex].valueCells[columnIndex].value = value;
            }
        });
        const isAssumableLoan = data.tabs['pricing-tab'].tables['pricing-analysis'].rows['assumable-loan-checkbox'].valueCells[1].value;
        if (proformaPricingViewChange)
            data.tabs = UnderwritingMultiTenant.changePricingView(data.tabs, isProformaPricing, isAssumableLoan, this.state.tenantsData);

        const state = {
            data,
        };
        if (reimbTypesManuallyModified)
            state.reimbTypesManuallyModified = reimbTypesManuallyModified;
        if (sqFtChanged !== null)
            state.sqFtUpdated = sqFtChanged;
        if (camChanged !== null)
            state.camPSFSumUpdated = camChanged;
        if (mgmtChanged !== null)
            state.mgmtUpdated = mgmtChanged;
        if (insuranceChanged !== null)
            state.insuranceUpdated = insuranceChanged;
        if (taxesChanged !== null)
            state.taxesUpdated = taxesChanged;
        this.setState(state, () => {
            // Toggling proforma for a retail property switches between the
            // `retail-MT` and `retail-MT-proforma` default-page sets.
            if (proformaPricingViewChange && this.props.data.CATEGORY === 'retail') {
                this.getStaticImages(this.getProductType());
            }
        });
    }

    addRow(tabIdentifiers, tableIdentifiers, rowIdentifier, isCAMRow = false, withReturn = false, externalData = null) {
        let data = externalData ? cloneDeep(externalData) : cloneDeep(this.state.data);
        let newRowIdentifier = Date.now().toString();

        // generate TABLE_ROW_ID
        let maxIndex = -1;
        if (tabIdentifiers.includes('current-rr-tab')) {
            const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
            const tableRowIdIndex = rows[0].valueCells.length - 1;  // TENANT_ROW_ID should always be the last column
            Object.keys(rows).forEach(key => {
                const value = parseInt(rows[key].valueCells[tableRowIdIndex].value);
                maxIndex =  value > maxIndex ? value : maxIndex;
            });

            // the keys have to be consecutive because of the drag & drop
            newRowIdentifier = Object.keys(rows).length;
        }

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                data.tabs[tabIdentifier] = this.addRowToTable(data.tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex);
            });
        });

        if (withReturn) return data;
        this.setState({data: data});
    }

    addRowToTable(tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex) {
        let rows = tabs[tabIdentifier].tables[tableIdentifier].rows;
        let auxRow = cloneDeep(rows[rowIdentifier]);
        const tableRowIdIndex = auxRow.valueCells.length - 1;  // TENANT_ROW_ID should always be the last column

        auxRow.valueCells.forEach((cell, index) => {
            if (['current-rr-tab', 'proforma-rr-tab', 'current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(tabIdentifier) &&
                ['general-information', 'detailed-information'].includes(tableIdentifier) &&
                index === tableRowIdIndex) {
                cell.value = newRowIdentifier.toString();
                return;
            }
            if ((cell.editable || cell.hidden) && cell.hasOwnProperty('value')) {
                cell.value = '';
            }
        });

        rows = Object.entries(rows);

        if (isCAMRow) {
            let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(rows);
            const defaultCamRowNo = 5;
            for (let index = 0; index < defaultCamRowNo; index++) {
                lastCamRowIndex++;
                rows.splice(lastCamRowIndex, 0, cloneDeep([`cam-${camNo + 1}`, auxRow]));
                camNo++;
            }
        } else {
            rows.push([newRowIdentifier, auxRow]);
        }

        const rowsObj = {};
        rows.map(item => {
            rowsObj[item[0]] = item[1];
        });

        tabs[tabIdentifier].tables[tableIdentifier].rows = rowsObj;

        return tabs[tabIdentifier];
    }

    deleteRowCurrentRR(rowIdentifier) {
        let data = cloneDeep(this.state.data);

        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['current-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['current-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['proforma-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'rent-roll', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'reimbursements', rowIdentifier, true);

        this.setState({data});
    }

    deleteRowFromTable(tab, tableIdentifier, rowIdentifier, consecutive) {
        const rowsCount = Object.keys(tab.tables[tableIdentifier].rows).length;
        if (rowsCount <= 1) {
            alert("You can't delete all the rows from the table!");
            return null;
        }

        if (consecutive) {
            // move rows up and delete the last one
            const tenantRowIdIndex = tab.tables[tableIdentifier].rows[rowIdentifier].valueCells.length - 1;
            for (let index = parseInt(rowIdentifier); index < rowsCount - 1; index++) {
                const tenantRowId = tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value;
                tab.tables[tableIdentifier].rows[index] = cloneDeep(tab.tables[tableIdentifier].rows[index + 1]);
                tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value = tenantRowId;
            }
            delete tab.tables[tableIdentifier].rows[rowsCount - 1];
        } else {
            delete tab.tables[tableIdentifier].rows[rowIdentifier];
        }

        return tab;
    }

    deleteRowCAM(tabIdentifiers, tableIdentifiers, rowIdentifier) {
        let data = cloneDeep(this.state.data);

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                const rows = data.tabs[tabIdentifier].tables[tableIdentifier].rows;
                const rowsAsArray = Object.entries(rows);
                let {camNo} = UnderwritingMultiTenant.findCamRowNO(rowsAsArray);

                if (camNo <= camDefaultRowNo) {
                    alert("You can't delete more rows from the table!");
                    return null;
                } else {
                    let camIndex = parseInt(rowIdentifier.split('-')[1], 10);
                    while (rows[`cam-${camIndex+1}`]) {
                        rows[`cam-${camIndex}`] = rows[`cam-${camIndex+1}`];
                        camIndex++;
                    }
                    delete rows[`cam-${camIndex}`];
                }
            });
        });

        this.setState({data: data});
    }

    moveRow({tabId, tableId, dragIndex, hoverIndex}) {
        const data = cloneDeep(this.state.data);
        const rows = data.tabs[tabId].tables[tableId].rows;
        const dragRow = cloneDeep(rows[dragIndex]);
        rows[dragIndex] = rows[hoverIndex];
        rows[hoverIndex] = dragRow;
        this.setState({
            data,
            movedRows: true,
        });
    }

    moveCorrespondingRows({changedTabId, changedTableId, tabIds, tableIds}) {
        // move all corresponding rows after dnd in Current Rent Roll general-information table & reset sort
        if (this.state.movedRows) {
            const data = cloneDeep(this.state.data);
            const changedRows = data.tabs[changedTabId].tables[changedTableId].rows;
            const valKeyIndex = changedRows[0].valueCells.length - 1;

            tabIds.map((tabId, index) => {
                tableIds[index].map(tableId => {
                    const keys = Object.keys(changedRows);
                    const rows = data.tabs[tabId].tables[tableId].rows;
                    const valueKeyIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
                    data.tabs[tabId].tables[tableId].rows = keys.reduce((obj, key) => ({...obj, [key]: findTenantRow(rows, valueKeyIndex, changedRows[key].valueCells[valKeyIndex].value)}), {});
                });
            });
            this.setState({
                data,
                sortState: 'default',
            });
        }
    }

    reassignTenantRowIds() {
        if (this.state.isBusy) return;

        const data = cloneDeep(this.state.data);
        const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
        const tenantRowId = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
        const ids = [];

        Object.keys(rows).forEach(key => {
            ids.push(rows[key].valueCells[tenantRowId].value);
        });
        ids.sort((a, b) => parseInt(a) - parseInt(b));

        Object.keys(rows).map((key, index) => {
            rows[key].valueCells[tenantRowId].value = ids[index];
        });

        this.setState({
            data,
            movedRows: false,
            isBusy: true,
        }, () => this.onSubmit());
    }

    findTenant(tenantName) {
        const tenants = this.props.allTenantsById;
        return find(tenants, {NAME: tenantName}) || null;
    }

    async saveTenant(tenantName) {
        const res = await request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.updateByTableCode',
            params: [TENANTS, {
                value: [{NAME: tenantName}],
            }],
        });
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            return res.data[0];
        }
        return null;
    }

    normalizePropertyTenantIds(tenantIdValue) {
        const ids = String(tenantIdValue || '')
            .split(',')
            .map(id => id.trim())
            .filter(Boolean);
        return [...new Set(ids)].join(',');
    }

    getFieldPropValue(data, prop) {
        if (prop.hasOwnProperty('valueCellIndex')) {
            return data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
        }
        return data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
    }

    parseUnderwritingNumberValue(value, prop) {
        if (value === '' || value === null || value === undefined) {
            return null;
        }
        const raw = prop.withReplace ? String(value).replace(/,/g, '') : String(value);
        const parsed = parseFloat(raw);
        return Number.isNaN(parsed) ? null : parsed;
    }

    /**
     * When saving any financial tab, re-include visible underwriting singleton fields
     * so a partial save + reload cannot drop data stored on an older duplicate row.
     */
    appendUnderwritingSingletonFieldsToPayload(data, underwritingData) {
        stringProps.filter(prop => !prop.fromProps).forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = this.getFieldPropValue(data, prop);
            if (value) {
                underwritingData[prop.key] = value;
            }
        });

        dateProps.filter(prop => !prop.fromProps).forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = this.getFieldPropValue(data, prop);
            if (!value) {
                return;
            }
            const isoValue = stringUStoISO(value);
            if (isoValue) {
                underwritingData[prop.key] = isoValue;
            }
        });

        numberProps.filter(prop => !prop.fromProps).forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = this.getFieldPropValue(data, prop);
            const parsed = this.parseUnderwritingNumberValue(value, prop);
            if (parsed !== null) {
                underwritingData[prop.key] = parsed;
            }
        });

        checkboxProps.forEach(prop => {
            if (underwritingData[prop.key] !== undefined) {
                return;
            }
            const value = this.getFieldPropValue(data, prop);
            underwritingData[prop.key] = value ? 1 : 0;
        });
    }

    normalizeTenantRowIdsForSave(data) {
        const generalRows = data.tabs['current-rr-tab'].tables['general-information'].rows;
        const rowKeys = Object.keys(generalRows).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
        const tenantRowTables = [
            ['current-rr-tab', 'general-information'],
            ['current-rr-tab', 'detailed-information'],
            ['proforma-rr-tab', 'general-information'],
            ['proforma-rr-tab', 'detailed-information'],
            ['current-reimbursement-tab', 'detailed-information'],
            ['proforma-reimbursement-tab', 'detailed-information'],
        ];

        rowKeys.forEach((rowKey, index) => {
            const tenantRowId = String(index);
            tenantRowTables.forEach(([tab, table]) => {
                const row = data.tabs[tab].tables[table].rows[rowKey];
                if (row && row.valueCells) {
                    row.valueCells[row.valueCells.length - 1].value = tenantRowId;
                }
            });
        });
    }

    parseTenantFieldNumber(value, prop) {
        if (value === '' || value === null || value === undefined) {
            return null;
        }
        const raw = prop.withReplace ? String(value).replace(/,/g, '') : String(value);
        const parsed = parseFloat(raw);
        return Number.isNaN(parsed) ? null : parsed;
    }

    async collectTenantSaveData(data, originalData, tenantsData, propertyId) {
        const newTenants = [];
        let savedTenants = false;
        const updatesByKey = {};
        const activeArcIds = new Set();
        const tenantNameChanges = [];

        const generalRows = data.tabs['current-rr-tab'].tables['general-information'].rows;
        const rowKeys = Object.keys(generalRows).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

        if (!rowKeys.length) {
            return {newTenantsData: [], newTenants, savedTenants};
        }

        const tenantRowIdIndex = generalRows[rowKeys[0]].valueCells.length - 1;
        const arcRowIdIndex = tenantRowIdIndex - 1;

        const getRows = (tab, table) => data.tabs[tab].tables[table].rows;
        const getOriginalRows = (tab, table) => originalData.tabs[tab].tables[table].rows;

        const ensureUpdate = (saveKey, rowKey, arcRowId) => {
            if (!updatesByKey[saveKey]) {
                updatesByKey[saveKey] = {
                    PROPERTY_ID: propertyId ? propertyId : this.props.newPropertyId,
                    DELETED: null,
                    TENANT_ROW_ID: String(rowKey),
                    ...(arcRowId ? {ARCIMEDES_ROW_ID: arcRowId} : {}),
                };
            }
            return updatesByKey[saveKey];
        };

        const getCellValue = (row, cellIndex) => {
            if (!row || !row.valueCells || !row.valueCells[cellIndex]) {
                return '';
            }
            const cellValue = row.valueCells[cellIndex].value;
            return cellValue === null || cellValue === undefined ? '' : cellValue;
        };

        const findOriginalTenantRow = (originalRows, rowKey, arcRowId) => {
            if (!originalRows) {
                return null;
            }
            if (arcRowId) {
                const sampleKey = Object.keys(originalRows)[0];
                const sampleRow = sampleKey != null ? originalRows[sampleKey] : null;
                const tableArcRowIdIndex = sampleRow && sampleRow.valueCells
                    ? sampleRow.valueCells.length - 2
                    : arcRowIdIndex;
                return findTenantRow(originalRows, tableArcRowIdIndex, arcRowId) || null;
            }
            return originalRows[rowKey] || null;
        };

        rowKeys.forEach(rowKey => {
            const arcRowId = generalRows[rowKey].valueCells[arcRowIdIndex].value;
            if (arcRowId) {
                activeArcIds.add(String(arcRowId));
            }

            const saveKey = arcRowId || `new-${rowKey}`;
            const isNewRow = !arcRowId;

            tenantFields.forEach(prop => {
                if (!prop.hasOwnProperty('valueCellIndex')) {
                    return;
                }
                if (prop.key === 'ARCIMEDES_ROW_ID' || prop.key === 'TENANT_ROW_ID') {
                    return;
                }

                const rows = getRows(prop.tab, prop.table);
                const originalRows = getOriginalRows(prop.tab, prop.table);
                if (!rows[rowKey] || !rows[rowKey].valueCells || !rows[rowKey].valueCells[prop.valueCellIndex]) {
                    return;
                }

                const value = getCellValue(rows[rowKey], prop.valueCellIndex);
                const originalRow = findOriginalTenantRow(originalRows, rowKey, arcRowId);
                const originalValue = getCellValue(originalRow, prop.valueCellIndex);

                const hasChange = value !== originalValue;
                const hasValue = value !== '' && value !== null && value !== undefined;
                if (!hasChange && !(isNewRow && hasValue)) {
                    return;
                }

                if (prop.key === 'TENANT_NAME') {
                    tenantNameChanges.push({saveKey, rowKey, value, arcRowId});
                    return;
                }

                const update = ensureUpdate(saveKey, rowKey, arcRowId);
                switch (prop.type) {
                    case 'string':
                        update[prop.key] = value;
                        break;
                    case 'number':
                        update[prop.key] = this.parseTenantFieldNumber(value, prop);
                        break;
                    case 'date':
                        update[prop.key] = value ? stringUStoISO(value) : null;
                        break;
                }
            });
        });

        for (const {saveKey, rowKey, value, arcRowId} of tenantNameChanges) {
            const update = ensureUpdate(saveKey, rowKey, arcRowId);
            const tenant = this.findTenant(value);
            if (!tenant) {
                const newTenant = await this.saveTenant(value);
                if (!newTenant || !newTenant.ARCIMEDES_ROW_ID) {
                    throw new Error(`Failed to create tenant "${value}"`);
                }
                newTenants.push({ARCIMEDES_ROW_ID: newTenant.ARCIMEDES_ROW_ID, NAME: value});
                update.TENANT_ID = newTenant.ARCIMEDES_ROW_ID;
            } else {
                update.TENANT_ID = tenant.ARCIMEDES_ROW_ID;
            }
            update.TENANT_NAME = value;
            savedTenants = true;
        }

        const newTenantsData = Object.values(updatesByKey);
        (tenantsData || []).forEach(dbTenant => {
            if (dbTenant.ARCIMEDES_ROW_ID && !activeArcIds.has(String(dbTenant.ARCIMEDES_ROW_ID))) {
                newTenantsData.push({
                    ARCIMEDES_ROW_ID: dbTenant.ARCIMEDES_ROW_ID,
                    DELETED: '1',
                });
            }
        });

        return {newTenantsData, newTenants, savedTenants};
    }

    rebuildPropertyTenantId(propsData, data, newTenantsData, tenantsData) {
        const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
        const rowKeys = rows ? Object.keys(rows) : [];
        if (!rowKeys.length) {
            return false;
        }

        const sampleRow = rows[rowKeys[0]];
        if (!sampleRow || !sampleRow.valueCells) {
            return false;
        }

        const tenantRowIdIndex = sampleRow.valueCells.length - 1;
        const arcRowIdIndex = tenantRowIdIndex - 1;
        const ids = [];
        const seen = new Set();

        rowKeys.forEach(key => {
            const row = rows[key];
            const tenantName = (row.valueCells[1].value || '').trim();
            if (!tenantName || tenantName.toLowerCase() === 'vacant') {
                return;
            }

            const tenantRowId = row.valueCells[tenantRowIdIndex].value;
            const arcRowId = row.valueCells[arcRowIdIndex].value;
            let tenantId = null;

            const pending = (newTenantsData || []).find(el => el && el.DELETED !== '1' && String(el.TENANT_ROW_ID) === String(tenantRowId));
            if (pending && pending.TENANT_ID) {
                tenantId = pending.TENANT_ID;
            } else if (tenantsData) {
                if (arcRowId) {
                    const existing = find(tenantsData, {ARCIMEDES_ROW_ID: arcRowId});
                    if (existing && existing.TENANT_ID) {
                        tenantId = existing.TENANT_ID;
                    }
                }
                if (!tenantId) {
                    const byRowId = find(tenantsData, row => String(row.TENANT_ROW_ID) === String(tenantRowId));
                    if (byRowId && byRowId.TENANT_ID) {
                        tenantId = byRowId.TENANT_ID;
                    }
                }
                if (!tenantId) {
                    const byName = find(tenantsData, row => (row.TENANT_NAME || '').trim() === tenantName);
                    if (byName && byName.TENANT_ID) {
                        tenantId = byName.TENANT_ID;
                    }
                }
            }
            if (!tenantId) {
                const tenant = this.findTenant(tenantName);
                if (tenant) {
                    tenantId = tenant.ARCIMEDES_ROW_ID;
                }
            }
            if (tenantId && !seen.has(String(tenantId))) {
                seen.add(String(tenantId));
                ids.push(String(tenantId));
            }
        });

        const originalTenantId = this.normalizePropertyTenantIds(this.props.data.TENANT_ID);
        const newTenantId = this.normalizePropertyTenantIds(ids.join(','));
        if (newTenantId !== originalTenantId) {
            propsData.TENANT_ID = newTenantId || null;
            return true;
        }
        return false;
    }

    async onSubmit() {
        try {
            await this.runSubmit();
        } catch (err) {
            console.error('Financials save error:', err);
            this.setState({isBusy: false});
            this.props.parentSetData({error: err && err.message ? err.message : 'Unidentified Error'});
        }
    }

    async runSubmit() {
        const {parcelsData, camData, tenantsData, tenantTypeData} = this.state;
        let data = this.state.data;
        const originalData = this.state.original;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.ARCIMEDES_ROW_ID;
        const underwritingData = {};
        let changesInPropData = false;

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
        // Compute Reimbursement Types values
        ['current-reimbursement-tab', 'proforma-reimbursement-tab'].forEach(tab => {
            const state = computeReimbTypes({
                result: data.tabs,
                tab: tab,
                precomputedValues,
                newSqft: this.state.sqFtUpdated,
                newCam: this.state.camPSFSumUpdated,
                newMgmt: this.state.mgmtUpdated,
                newInsurance: this.state.insuranceUpdated,
                newTaxes: this.state.taxesUpdated,
                reimbTypesManuallyModified: this.state.reimbTypesManuallyModified,
            });
            data = state.data;
        });
        stringProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value;
                }
            }
        });

        dateProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                const isoValue = value ? stringUStoISO(value) : null;
                const origIso = originalValue ? stringUStoISO(originalValue) : null;
                if (isoValue !== origIso) {
                    underwritingData[prop.key] = isoValue;
                }
            }
        });

        numberProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (prop.withReplace) {
                    if (value !== originalValue) {
                        propsData[prop.key] = addCommasToNumber(value);
                        changesInPropData = true;
                    }
                    return;
                }
                if (value !== originalValue) {
                    propsData[prop.key] = value.toString();
                    changesInPropData = true;
                }
            } else {
                if (value !== originalValue) {
                    let parsed;
                    if (prop.withReplace) {
                        parsed = value === '' || value === null
                            ? null
                            : parseFloat(String(value).replace(/,/g, ''));
                    } else {
                        parsed = parseFloat(value);
                    }
                    underwritingData[prop.key] = value === '' || value === null || Number.isNaN(parsed) ? null : parsed;
                }
            }
        });

        checkboxProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            // set underwritingData just if the value has been changed
            if (value !== originalValue)
                underwritingData[prop.key] = value ? 1 : 0;

        });

        const noi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaNoi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaCapRate = data.tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value;
        const proformaBaseRent = data.tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        

        if (noi > 0) {
            propsData.NET_OPERATING_INCOME = addCommasToNumber(noi);
        }
        // Proforma property financials changes
        if (proformaNoi > 0) {
            propsData.PROFORMA_NOI = proformaNoi;
        }
        if(proformaBaseRent > 0){
            propsData.PROFORMA_BASE_RENT = proformaBaseRent;
        }
        if(proformaCapRate > 0){
            propsData.PROFORMA_CAP_RATE = proformaCapRate;
        }


        const listPrice = data.tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (listPrice > 0) {
            propsData.LIST_PRICE = addCommasToNumber(listPrice);
        }
        const baseRent = data.tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (baseRent > 0) {
            propsData.BASE_RENT = addCommasToNumber(baseRent);
        }
        const sqft = data.tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(data.tabs, '', precomputedValues).internalValue;
        if (sqft > 0 && !propsData.SQFT) {
            propsData.SQFT = addCommasToNumber(sqft);
        }
        propsData.VACANCY = data.tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(data.tabs, precomputedValues).internalValue;

        // set underwriting parcels cam just if the value has been changed
        const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
        const originalParcels = originalData.tabs['property-information-tab'].tables['parcel'].rows;
        const newParcelsData = [];
        const parcelCols = ['PARCEL', 'ASSESSED_VALUE', 'TAX_LIABILITY'];

        for (let index = 0; index < 4; index++) {
            const parcelObj = {};
            parcels[`tax-assessment-${index+1}`].valueCells.map((tax, taxIndex) => {
                if (tax.value !== originalParcels[`tax-assessment-${index+1}`].valueCells[taxIndex].value) {
                    parcelObj[parcelCols[taxIndex]] = tax.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(parcelObj).length && propertyId) {
                parcelObj.PROPERTY_ID = propertyId;
                if (parcelsData && parcelsData[index] && parcelsData[index].ARCIMEDES_ROW_ID) {
                    parcelObj.ARCIMEDES_ROW_ID = parcelsData[index].ARCIMEDES_ROW_ID;
                }
                newParcelsData.push(parcelObj);
            }
        }

        // set underwriting expenses cam just if the value has been changed
        const cams = data.tabs['expenses-tab'].tables['expenses'].rows;
        const originalCam = originalData.tabs['expenses-tab'].tables['expenses'].rows;
        const newCamData = [];
        const camCols = ['CAM_NAME', '', 'CAM_VALUE', '', '', 'PROFORMA_CAM_VALUE', ''];
        const camRows = Object.entries(cams);
        const {camNo} = UnderwritingMultiTenant.findCamRowNO(camRows);
        const deletedRows = camData ? cloneDeep(camData) : [];
        const arcRowIdIndex = cams['cam-1'].valueCells.length - 1;

        for (let index = 0; index < camNo; index++) {
            const camObj = {};
            const camKey = `cam-${index+1}`;
            const rowId = cams[camKey].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only the deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {ARCIMEDES_ROW_ID: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            const lastIndex = cams[camKey].valueCells.length - 2;
            cams[camKey].valueCells.map((cam, camIndex) => {
                if (camIndex < lastIndex &&
                    (!originalCam[camKey] && cam.editable ||
                     originalCam[camKey] && cam.value !== originalCam[camKey].valueCells[camIndex].value)) {
                    camObj[camCols[camIndex]] = cam.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(camObj).length && propertyId) {
                camObj.PROPERTY_ID = propertyId;
                camObj.CAM_INDEX = index + 1;
                if (rowId)
                    camObj.ARCIMEDES_ROW_ID = rowId;
                newCamData.push(camObj);
            }
        }

        deletedRows.map(row => {
            newCamData.push({
                ARCIMEDES_ROW_ID: row.ARCIMEDES_ROW_ID,
                DELETED: 1,
            });
        });

        this.normalizeTenantRowIdsForSave(data);
        const {
            newTenantsData,
            newTenants,
            savedTenants,
        } = await this.collectTenantSaveData(data, originalData, tenantsData, propertyId);

        if (newTenantsData.length > 0 && this.rebuildPropertyTenantId(propsData, data, newTenantsData, tenantsData)) {
            changesInPropData = true;
        }

        // set underwriting current & pro forma reimbursement types just if the value has been changed
        const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypes = originalData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypesProForma = originalData.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesByIndex = indexTenantTypesByReimbIndex(tenantTypeData);
        const newTenantTypesData = [];

        Object.keys(tenantTypes).forEach(key => {
            const persistedRow = resolveTenantTypeRow(tenantTypesByIndex, parseInt(key, 10), tenantTypeData);
            const tenantTypeObj = buildTenantTypeSaveRow({
                key,
                tenantTypes,
                originalTenantTypes,
                tenantTypesProForma,
                originalTenantTypesProForma,
                tenantTypeFields,
                propertyId,
                persistedRow,
            });
            if (tenantTypeObj) {
                newTenantTypesData.push(tenantTypeObj);
            }
        });

        if (this.state.reimbTypesManuallyModified !== this.state.originalReimbTypesManuallyModified)
            underwritingData.REIMB_TYPES_MANUALLY_MODIFIED = this.state.reimbTypesManuallyModified ? 1 : 0;

        const id = propertyId ? propertyId : this.props.newPropertyId;
        if (!propertyId)
            propsData.ARCIMEDES_ROW_ID = this.props.newPropertyId;

        // Sync underwriting fields back to property
        const cadLink1Value = data.tabs['property-information-tab'].tables['links'].rows['tax-assessment-link-1'].value;
        const originalCadLink1Value = originalData.tabs['property-information-tab'].tables['links'].rows['tax-assessment-link-1'].value;
        if (cadLink1Value !== originalCadLink1Value) {
            propsData.CAD_SITE = cadLink1Value || '';
            changesInPropData = true;
        }
        const lotSizeValue = data.tabs['property-information-tab'].tables['other-information'].rows['lot-size'].value;
        const originalLotSizeValue = originalData.tabs['property-information-tab'].tables['other-information'].rows['lot-size'].value;
        if (lotSizeValue !== originalLotSizeValue) {
            propsData.ACRES = lotSizeValue ? lotSizeValue.toString() : '';
            changesInPropData = true;
        }
        const taxAppraisedValue = data.tabs['property-information-tab'].tables['other-information'].rows['current-tax-appraised-value'].value;
        const originalTaxAppraisedValue = originalData.tabs['property-information-tab'].tables['other-information'].rows['current-tax-appraised-value'].value;
        if (taxAppraisedValue !== originalTaxAppraisedValue) {
            propsData.ASSESSED_VALUE = taxAppraisedValue ? addCommasToNumber(taxAppraisedValue) : '';
            changesInPropData = true;
        }

        this.appendUnderwritingSingletonFieldsToPayload(data, underwritingData);

        const noChangesDetected = !Object.keys(underwritingData).length && newParcelsData.length < 1 && newCamData.length < 1 && newTenantsData.length < 1 && newTenantTypesData.length < 1 && !changesInPropData;
        const success = noChangesDetected ? 'No data to update' : '';


        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({isBusy: false});
            this.props.parentSetData({success})
            return;
        };

        const saveTasks = [];

        if (Object.keys(underwritingData).length > 0) {
            underwritingData.PROPERTY_ID = id;
            if (this.state.underwritingId) {
                underwritingData.ARCIMEDES_ROW_ID = this.state.underwritingId;
            }
            saveTasks.push(
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.updateByTableCode',
                    params: [UNDERWRITING_MULTI_TENANT, {
                        value: [underwritingData],
                    }]
                })
            );
        }

        if (newParcelsData.length > 0) {
            saveTasks.push(
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.updateByTableCode',
                    params: [UNDERWRITING_PARCELS, {
                        value: newParcelsData,
                    }]
                })
            );
        }

        if (newCamData.length > 0) {
            saveTasks.push(
                request(arc.path.api, {
                    service: 'arcimedes',
                    action: 'open.datasource.table.Data.updateByTableCode',
                    params: [UNDERWRITING_EXPENSES_CAMS, {
                        value: newCamData,
                    }]
                })
            );
        }

        if (newTenantsData.length > 0) {
            saveTasks.push(
                manageData({
                    tableCode: UNDERWRITING_TENANTS,
                    data: newTenantsData,
                })
            );
        }

        if (newTenantTypesData.length > 0) {
            saveTasks.push(
                manageData({
                    tableCode: UNDERWRITING_TENANT_TYPES,
                    data: newTenantTypesData,
                })
            );
        }

        return Promise.all(saveTasks).then(async (results) => {
            const failed = results.find(res => !res || !res.success);
            if (failed) {
                this.setState({isBusy: false});
                this.props.parentSetData({error: failed.message || 'Unidentified Error'});
                return;
            }

            let underwritingId = this.state.underwritingId;
            if (Object.keys(underwritingData).length > 0) {
                const mtResult = results[0];
                if (mtResult && mtResult.success && Array.isArray(mtResult.data) && mtResult.data[0]) {
                    underwritingId = mtResult.data[0].ARCIMEDES_ROW_ID || underwritingId;
                }
            }

            this.setState({underwritingId});
            this.props.parentSetData({
                newData: propsData,
                savedTenants,
                newTenants,
                success: 'Saved',
            });
            await this.getUnderwritingData(true);
            this.setState({isBusy: false});
        }).catch((err) => {
            console.error('Financials save error:', err);
            this.setState({isBusy: false});
            this.props.parentSetData({error: err && err.message ? err.message : 'Unidentified Error'});
        });
    }

    handleExpand({tabId, tablesId, rowsId, cellsId}) {
        let data = cloneDeep(this.state.data);
        const tables = data.tabs[tabId].tables;

        tablesId.map(tableId => {
            const rows = tables[tableId].rows ? tables[tableId].rows : {};
            const rId = rowsId && rowsId[tableId] ? rowsId[tableId] : Object.keys(rows);
            rId.map(rowId => {
                const cId = cellsId ? cellsId : Object.keys(rows[rowId].valueCells);
                cId.map(cellId => {
                    rows[rowId].valueCells[cellId].hidden = !rows[rowId].valueCells[cellId].hidden;
                });
            });

            const footerRow = tables[tableId].footerRow ? tables[tableId].footerRow : {};
            if (Object.keys(footerRow).length && cellsId) {
                cellsId.map(cellId => {
                    footerRow.valueCells[cellId].hidden = !footerRow.valueCells[cellId].hidden;
                });
            }
        });

        this.setState({data});
    }

    handleExpandShow({tabId, tablesId, rowsId, cellsId,toggleState}) {
        let data = cloneDeep(this.state.data);
        const tables = data.tabs[tabId].tables;

        tablesId.map(tableId => {
            const rows = tables[tableId].rows ? tables[tableId].rows : {};
            const rId = rowsId && rowsId[tableId] ? rowsId[tableId] : Object.keys(rows);
            rId.map(rowId => {
                const cId = cellsId ? cellsId : Object.keys(rows[rowId].valueCells);
                cId.map(cellId => {
                    rows[rowId].valueCells[cellId].hidden = toggleState;
                });
            });

            const footerRow = tables[tableId].footerRow ? tables[tableId].footerRow : {};
            if (Object.keys(footerRow).length && cellsId) {
                cellsId.map(cellId => {
                    footerRow.valueCells[cellId].hidden = toggleState;
                });
            }
        });

        this.setState({data});
    }

    sortTenants(key, sort, sortState) {
        let data = cloneDeep(this.state.data);
        this.setState({movedRows: sortState === 'asc' || sortState === 'desc'});
        this.getTenants(data, key, sort, sortState);
    }

    getStaticImages(type){
        const seq = (this._staticImagesSeq = (this._staticImagesSeq || 0) + 1);
        this.setState({ staticImagesLoading: true });
        return getData({tableCode:PRICING_ANALYSIS,
            options:{
                filterType:'and',
                filter: [{
                    text: type,
                    code: 'PRODUCT_TYPE',
                    type: 'exact',
                }]
            },
        }).then((res)=>{
            if (seq !== this._staticImagesSeq) return;
            if (res && res.success && res.data && res.data.length) {
                try {
                    const items = preProcess(res.data[0].ITEMS);
                    this.setState({ staticImages: items, staticImagesLoaded: true, staticImagesLoading: false });
                    return items;
                } catch (e) {
                    this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
                }
            } else {
                this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
            }
        }).catch(() => {
            if (seq !== this._staticImagesSeq) return;
            this.setState({ staticImages: [], staticImagesLoaded: true, staticImagesLoading: false });
        });
    }

    onConfirm(){
        this.setState({isDialogueOpen: false});
        this.onSubmit()
    }
    onCancel(){
        this.setState({isDialogueOpen: false, isBusy: false});
    }
    async beforeSubmit(){

        if(this.state.isBusy)return;
        this.setState({isBusy: true});
        
        try {
            if(!(["Active", "In Negotiation", "Under Contract"].includes(this.props.data.STATUS) && this.props.data.SOURCE === "SUMMIT")){
                await this.onSubmit();
                return;
            }
            
            await this.prepareSummitConfirmDialog();
        } catch (err) {
            console.error('Financials save error:', err);
            this.setState({isBusy: false});
            this.props.parentSetData({error: err && err.message ? err.message : 'Unidentified Error'});
        }
    }

    async prepareSummitConfirmDialog(){
        const {parcelsData, camData, tenantsData, tenantTypeData} = this.state;
        let data = this.state.data;
        const originalData = this.state.original;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.ARCIMEDES_ROW_ID;
        const underwritingData = {};
        let changesInPropData = false;

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.data.tabs);
        // Compute Reimbursement Types values
        ['current-reimbursement-tab', 'proforma-reimbursement-tab'].forEach(tab => {
            const state = computeReimbTypes({
                result: data.tabs,
                tab: tab,
                precomputedValues,
                newSqft: this.state.sqFtUpdated,
                newCam: this.state.camPSFSumUpdated,
                newMgmt: this.state.mgmtUpdated,
                newInsurance: this.state.insuranceUpdated,
                newTaxes: this.state.taxesUpdated,
                reimbTypesManuallyModified: this.state.reimbTypesManuallyModified,
            });
            data = state.data;
        });
        stringProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value;
                }
            }
        });

        dateProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (value !== originalValue) {
                    propsData[prop.key] = value;
                    changesInPropData = true;
                }
            } else {
                // set underwritingData just if the value has been changed
                const isoValue = value ? stringUStoISO(value) : null;
                const origIso = originalValue ? stringUStoISO(originalValue) : null;
                if (isoValue !== origIso) {
                    underwritingData[prop.key] = isoValue;
                }
            }
        });

        numberProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (prop.withReplace) {
                    if (value !== originalValue) {
                        propsData[prop.key] = addCommasToNumber(value);
                        changesInPropData = true;
                    }
                    return;
                }
                if (value !== originalValue) {
                    propsData[prop.key] = value.toString();
                    changesInPropData = true;
                }
            } else {
                if (value !== originalValue) {
                    let parsed;
                    if (prop.withReplace) {
                        parsed = value === '' || value === null
                            ? null
                            : parseFloat(String(value).replace(/,/g, ''));
                    } else {
                        parsed = parseFloat(value);
                    }
                    underwritingData[prop.key] = value === '' || value === null || Number.isNaN(parsed) ? null : parsed;
                }
            }
        });

        checkboxProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            // set underwritingData just if the value has been changed
            if (value !== originalValue)
                underwritingData[prop.key] = value ? 1 : 0;

        });

        const noi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaNoi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        const proformaCapRate = data.tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value;
        const proformaBaseRent = data.tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[6].getComputedValue(data.tabs, precomputedValues).internalValue;
        

        if (noi > 0) {
            propsData.NET_OPERATING_INCOME = addCommasToNumber(noi);
        }
        // Proforma property financials changes
        if (proformaNoi > 0) {
            propsData.PROFORMA_NOI = proformaNoi;
        }
        if(proformaBaseRent > 0){
            propsData.PROFORMA_BASE_RENT = proformaBaseRent;
        }
        if(proformaCapRate > 0){
            propsData.PROFORMA_CAP_RATE = proformaCapRate;
        }


        const listPrice = data.tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (listPrice > 0) {
            propsData.LIST_PRICE = addCommasToNumber(listPrice);
        }
        const baseRent = data.tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (baseRent > 0) {
            propsData.BASE_RENT = addCommasToNumber(baseRent);
        }
        const sqft = data.tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(data.tabs, '', precomputedValues).internalValue;
        if (sqft > 0 && !propsData.SQFT) {
            propsData.SQFT = addCommasToNumber(sqft);
        }
        propsData.VACANCY = data.tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(data.tabs, precomputedValues).internalValue;

        // set underwriting parcels cam just if the value has been changed
        const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
        const originalParcels = originalData.tabs['property-information-tab'].tables['parcel'].rows;
        const newParcelsData = [];
        const parcelCols = ['PARCEL', 'ASSESSED_VALUE', 'TAX_LIABILITY'];

        for (let index = 0; index < 4; index++) {
            const parcelObj = {};
            parcels[`tax-assessment-${index+1}`].valueCells.map((tax, taxIndex) => {
                if (tax.value !== originalParcels[`tax-assessment-${index+1}`].valueCells[taxIndex].value) {
                    parcelObj[parcelCols[taxIndex]] = tax.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(parcelObj).length && propertyId) {
                parcelObj.PROPERTY_ID = propertyId;
                if (parcelsData && parcelsData[index] && parcelsData[index].ARCIMEDES_ROW_ID) {
                    parcelObj.ARCIMEDES_ROW_ID = parcelsData[index].ARCIMEDES_ROW_ID;
                }
                newParcelsData.push(parcelObj);
            }
        }

        // set underwriting expenses cam just if the value has been changed
        const cams = data.tabs['expenses-tab'].tables['expenses'].rows;
        const originalCam = originalData.tabs['expenses-tab'].tables['expenses'].rows;
        const newCamData = [];
        const camCols = ['CAM_NAME', '', 'CAM_VALUE', '', '', 'PROFORMA_CAM_VALUE', ''];
        const camRows = Object.entries(cams);
        const {camNo} = UnderwritingMultiTenant.findCamRowNO(camRows);
        const deletedRows = camData ? cloneDeep(camData) : [];
        const arcRowIdIndex = cams['cam-1'].valueCells.length - 1;

        for (let index = 0; index < camNo; index++) {
            const camObj = {};
            const camKey = `cam-${index+1}`;
            const rowId = cams[camKey].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only the deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {ARCIMEDES_ROW_ID: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            const lastIndex = cams[camKey].valueCells.length - 2;
            cams[camKey].valueCells.map((cam, camIndex) => {
                if (camIndex < lastIndex &&
                    (!originalCam[camKey] && cam.editable ||
                     originalCam[camKey] && cam.value !== originalCam[camKey].valueCells[camIndex].value)) {
                    camObj[camCols[camIndex]] = cam.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(camObj).length && propertyId) {
                camObj.PROPERTY_ID = propertyId;
                camObj.CAM_INDEX = index + 1;
                if (rowId)
                    camObj.ARCIMEDES_ROW_ID = rowId;
                newCamData.push(camObj);
            }
        }

        deletedRows.map(row => {
            newCamData.push({
                ARCIMEDES_ROW_ID: row.ARCIMEDES_ROW_ID,
                DELETED: 1,
            });
        });

        this.normalizeTenantRowIdsForSave(data);
        const {
            newTenantsData,
            newTenants,
            savedTenants,
        } = await this.collectTenantSaveData(data, originalData, tenantsData, propertyId);

        if (newTenantsData.length > 0 && this.rebuildPropertyTenantId(propsData, data, newTenantsData, tenantsData)) {
            changesInPropData = true;
        }

        // set underwriting current & pro forma reimbursement types just if the value has been changed
        const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypes = originalData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypesProForma = originalData.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesByIndex = indexTenantTypesByReimbIndex(tenantTypeData);
        const newTenantTypesData = [];

        Object.keys(tenantTypes).forEach(key => {
            const persistedRow = resolveTenantTypeRow(tenantTypesByIndex, parseInt(key, 10), tenantTypeData);
            const tenantTypeObj = buildTenantTypeSaveRow({
                key,
                tenantTypes,
                originalTenantTypes,
                tenantTypesProForma,
                originalTenantTypesProForma,
                tenantTypeFields,
                propertyId,
                persistedRow,
            });
            if (tenantTypeObj) {
                newTenantTypesData.push(tenantTypeObj);
            }
        });

        if (this.state.reimbTypesManuallyModified !== this.state.originalReimbTypesManuallyModified)
            underwritingData.REIMB_TYPES_MANUALLY_MODIFIED = this.state.reimbTypesManuallyModified ? 1 : 0;

        const id = propertyId ? propertyId : this.props.newPropertyId;
        if (Object.keys(underwritingData).length)
            underwritingData.PROPERTY_ID = id;
        if (!propertyId)
            propsData.ARCIMEDES_ROW_ID = this.props.newPropertyId;

        this.appendUnderwritingSingletonFieldsToPayload(data, underwritingData);

        const noChangesDetected = !Object.keys(underwritingData).length && newParcelsData.length < 1 && newCamData.length < 1 && newTenantsData.length < 1 && newTenantTypesData.length < 1 && !changesInPropData;
        const success = noChangesDetected ? 'No data to update' : '';


        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({isBusy: false});
            this.props.parentSetData({success})
            return;
        };

        const originalDataPrecomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.state.original.tabs);

        if(this.state.data.tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(this.state.data.tabs, '', precomputedValues).internalValue !== this.state.original.tabs['marketing-tab'].tables['offering-summary'].rows['price'].getComputedValue(this.state.original.tabs, '', originalDataPrecomputedValues).internalValue){
            this.setState({isDialogueOpen: true, dialogTitle:'Do you have an Amendment to the Rep Agreement to change the price?'});
        }else{
            this.setState({isDialogueOpen: true, dialogTitle:'Are you sure you want to save this financial data?'});
        }
    }

    render() {
        const {data, selectedTab, sqFtUpdated, camPSFSumUpdated, mgmtUpdated, insuranceUpdated, taxesUpdated, dataLoaded, movedRows, reimbTypesManuallyModified, staticImages} = this.state;
        const propertyImage = this.props.data.WEBSITE_PHOTO_1 ? this.props.data.WEBSITE_PHOTO_1 : '';
        const agents = this.props.agents;
        const disabled = !!this.props.readOnlySnapshot || !(editsEverySummitRecord(getCurrentAccess()) || this.props.agentIsCurrentUser && ['Proposal', 'Property Info', 'Off Market', 'Removed'].includes(this.props.data.STATUS));
        const propertyMapProps = {
            LATITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LATITUDE) : 0,
            LONGITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LONGITUDE) : 0,
            NAME: this.props.data.NAME
        };
        
        const isCategoryOffice = this.props.data.CATEGORY == "office";
        const isIndustrial = this.props.data.CATEGORY == "industrial";
        const isCategoryRetail = this.props.data.CATEGORY == "retail";
        return (
            <div>
                <PopupDialog
                    title={this.state.dialogTitle} 
                    isOpen={this.state.isDialogueOpen} 
                    onConfirm={() => { this.onConfirm()}}
                    onCancel={() => {this.onCancel()}}
                />
                {this.state.staticImagesLoading ? (
                    <div className="Financials_print_assets_overlay" role="status" aria-live="polite" aria-busy="true">
                        <div className="Financials_print_assets_overlay_panel">
                            <div className="Financials_print_assets_overlay_spinner" aria-hidden="true" />
                            <p className="Financials_print_assets_overlay_message">Please wait, generating print assets...</p>
                        </div>
                    </div>
                ) : null}
                <PrintMultiTenant staticImages={this.state.staticImagesLoaded ? staticImages : defualtStaticImages} isCategoryOffice={isCategoryOffice} isIndustrial={isIndustrial} location={this.props.location} proposalData={this.props.proposalData} tabs={data.tabs} propertyImage={propertyImage} propertyMapProps={propertyMapProps} agents={agents}/>
                <div className="Financials_content multi_tenant_content">
                    {/* <div onMouseEnter={this.togglePopupMessage} onMouseLeave={this.togglePopupMessage} className='placeholder-button'/> */}
                    {isCategoryRetail ? (
                        <label className='Financials_california_toggle'>
                            <input
                                type='checkbox'
                                checked={this.state.isCaliforniaProposal}
                                onChange={this.handleCaliforniaToggle}
                                disabled={this.state.staticImagesLoading}
                            />
                            <span>California Proposal{this.state.staticImagesLoading ? ' (loading...)' : ''}</span>
                        </label>
                    ) : null}
                    <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={(e)=>{e.preventDefault(); movedRows ? this.reassignTenantRowIds() : this.beforeSubmit()}} disabled={disabled || this.state.isBusy}>Submit</button>
                    {disabled && this.state.displayPopupSubmit ? <div className='Financials_submit_message'>Don't have permission to save.</div> : null}
                    <div className="multi_tenant_tabs">
                        {Object.keys(data.tabs).map((tabKey) => {
                            const tab = data.tabs[tabKey];
                            return (
                                <div className={`tab ${selectedTab}${selectedTab === tabKey ? ' selected' : ''}${dataLoaded ? '' : ' disabled'}`} key={tabKey} onClick={() => {this.changeTab(tabKey)}}>
                                    {tab.name}
                                </div>
                            )
                        })}
                    </div>
                    <div className="content">
                        {selectedTab === 'marketing-tab' ?
                            <Marketing tabs={data.tabs} valueChange={this.tabValueChange} setState={this.setState} handleExpand={this.handleExpand}
                                       isMarketingAdditionalPriceVisible={this.state.isMarketingAdditionalPriceVisible} handleExpandShow={this.handleExpandShow}/>
                            : selectedTab === 'property-information-tab' ?
                                <PropertyInformation tabs={data.tabs} valueChange={this.tabValueChange}/>
                                : selectedTab === 'pricing-tab' ?
                                    <Pricing tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange} handleExpand={this.handleExpand}
                                             setState={this.setState} isProformaVisiblePricing={this.state.isProformaVisiblePricing} isAdditionalPriceVisible={this.state.isAdditionalPriceVisible}/>
                                    : selectedTab === 'current-rr-tab' ?
                                        <CurrentRR tabs={data.tabs} tab='current-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                   addRow={this.addRow} deleteRow={this.deleteRowCurrentRR} moveRow={this.moveRow} moveCorrespondingRows={this.moveCorrespondingRows}
                                                   sortState={this.state.sortState} sortTenants={this.sortTenants}/>
                                        : selectedTab === 'current-reimbursement-tab' ?
                                            <CurrentReimbursement tabs={data.tabs} tab='current-reimbursement-tab' reimbTypesManuallyModified={reimbTypesManuallyModified}
                                                                  setState={this.setState} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                                  sqFtUpdated={sqFtUpdated} camPSFSumUpdated={camPSFSumUpdated} mgmtUpdated={mgmtUpdated} insuranceUpdated={insuranceUpdated} taxesUpdated={taxesUpdated}/>
                                            : selectedTab === 'expenses-tab' ?
                                                <Expenses tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                          addRow={this.addRow} deleteRow={this.deleteRowCAM}
                                                          handleExpand={this.handleExpand} setState={this.setState}
                                                          isProformaVisible={this.state.isProformaVisible}/>
                                                : selectedTab === 'proforma-rr-tab' ?
                                                    <CurrentRR tabs={data.tabs} tab='proforma-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                               addRow={this.addRow} deleteRow={this.deleteRowCurrentRR}/>
                                                    : selectedTab === 'proforma-reimbursement-tab' ?
                                                        <CurrentReimbursement tabs={data.tabs} tab='proforma-reimbursement-tab' reimbTypesManuallyModified={reimbTypesManuallyModified}
                                                                              setState={this.setState} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                                              camPSFSumUpdated={camPSFSumUpdated} mgmtUpdated={mgmtUpdated} insuranceUpdated={insuranceUpdated} taxesUpdated={taxesUpdated}/>
                                                        : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}